import { render, staticRenderFns } from "./PhoneNumbers.vue?vue&type=template&id=2cdc5ef2&scoped=true&"
import script from "./PhoneNumbers.vue?vue&type=script&lang=js&"
export * from "./PhoneNumbers.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumbers.vue?vue&type=style&index=0&id=2cdc5ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc5ef2",
  null
  
)

export default component.exports